import React from "react"
import * as Yup from "yup"
import { Col, Row, CardTitle, Label, Input } from "reactstrap"

import { useCreatePermissionMutation } from "store/api/permissions/permissions.api"
import { useFormik } from "formik"
import { Link, useNavigate } from "react-router-dom"
import toast from "react-hot-toast"
import {
  checkExtension,
  formatAmount,
  getBusinsessAddress,
  renderAddressValue,
  showRegistrationType,
} from "helpers/common"
import pdfIcon from "../../assets/images/icons/file-type.svg"
import imageIcon from "../../assets/images/icons/image.svg"
import moment from "moment"
import { businessFiles } from "helpers/utils"

const NonIndividualView = ({ partnerData }) => {
  const navigate = useNavigate()
  const [mutate] = useCreatePermissionMutation()
  //meta title
  document.title = "Investor Details  | Prachay"

  const onFormSubmit = async (values) => {
    try {
      const response = await mutate(values).unwrap()
      if (response.success) {
        navigate("/investor")
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        horizontalformik.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const horizontalformik = useFormik({
    initialValues: {
      module: "",
      key: "",
      label: "",
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })
  return (
    <React.Fragment>
      <Row>
        <Col xl={12}>
          <Row className="mb-2">
            <Col xl={6}>
              <Label className="col-form-label">Name of the Entity</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={partnerData?.investorCompanyDetails?.entity_name}
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Date of Incorporation</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={
                  partnerData?.investorCompanyDetails?.date_of_incorporation
                }
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Constitution of Business</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={
                  partnerData?.investorCompanyDetails?.constitution_of_business
                }
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Registered Address</Label>
              <Input
                disabled
                name="name"
                type="textarea"
                className="form-control"
                value={getBusinsessAddress(partnerData?.investorCompanyDetails)}
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Communication Address</Label>
              <Input
                disabled
                name="name"
                type="textarea"
                className="form-control"
                value={
                  partnerData?.investorCompanyDetails?.is_comm_address_same ===
                  "SAME"
                    ? getBusinsessAddress(partnerData?.investorCompanyDetails)
                    : renderAddressValue(
                        partnerData?.investorCompanyDetails
                          ?.communication_address
                      )
                }
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">PAN</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={partnerData?.pan_no}
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">GSTIN</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={
                  partnerData?.investorCompanyDetails?.gstin || "Not Applicable"
                }
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Phone No.</Label>
              <Input
                disabled
                name="phone"
                type="text"
                className="form-control"
                value={partnerData?.phone}
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Email Address</Label>
              <Input
                disabled
                name="email"
                type="text"
                className="form-control"
                value={partnerData?.email}
              />
            </Col>
            {/* <Col xl={6}>
              <Label className="col-form-label">Political Exposure</Label>
              <Input
                disabled
                name="email"
                type="text"
                className="form-control"
                value={
                  partnerData?.businessAdditionalDetails?.politicalExposure
                }
              />
            </Col> */}
            {partnerData?.businessAdditionalDetails
              ?.constitution_of_business !== "Hindu Undivided Family" && (
              <Col xl={6}>
                <Label className="col-form-label">
                  {`Entity Registration No.${
                    showRegistrationType(
                      partnerData?.businessAdditionalDetails
                        ?.constitution_of_business
                    )?.trim()
                      ? ` (${showRegistrationType(
                          partnerData?.businessAdditionalDetails
                            ?.constitution_of_business
                        )})`
                      : ""
                  }`}
                </Label>
                <Input
                  disabled
                  name="email"
                  type="text"
                  className="form-control"
                  value={
                    partnerData?.businessAdditionalDetails
                      ?.entity_registration_no || "Not Applicable"
                  }
                />
              </Col>
            )}
          </Row>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <div>
            <div>
              <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                <CardTitle className="">Bank Details</CardTitle>
              </div>
              <Row className="mb-2">
                <Col xl={6}>
                  <Label className="col-form-label">Account Holders Name</Label>
                  <Input
                    disabled
                    name="account_holder"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.account_holder}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Account Number</Label>
                  <Input
                    disabled
                    name="account_no"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.account_no}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Bank Name</Label>
                  <Input
                    disabled
                    name="bank_name"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.bank_name}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">IFSC</Label>
                  <Input
                    disabled
                    name="ifsc"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.ifsc}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Account Type</Label>
                  <Input
                    disabled
                    name="ifsc"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.account_type}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <div>
            <div>
              <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                <CardTitle className="">Authorised Person Details</CardTitle>
              </div>
              <Row className="mb-2">
                <Col xl={6}>
                  <Label className="col-form-label">Name</Label>
                  <Input
                    disabled
                    name="name"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsAadhaar?.name}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Date of Birth</Label>
                  <Input
                    disabled
                    name="depository_participant_name"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsAadhaar?.dob}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">PAN</Label>
                  <Input
                    disabled
                    name="exchange_type"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsPAN?.pan}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Aadhaar No.</Label>
                  <Input
                    disabled
                    name="exchange_type"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsAadhaar?.aadhaar_no}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Designation</Label>
                  <Input
                    disabled
                    name="exchange_type"
                    type="text"
                    className="form-control"
                    value={partnerData?.businessAdditionalDetails?.designation}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">
                    {partnerData?.businessAdditionalDetails
                      ?.constitution_of_business ===
                    "Limited Liability Partnership"
                      ? "DPIN"
                      : "DIN"}
                  </Label>
                  <Input
                    disabled
                    name="exchange_type"
                    type="text"
                    className="form-control"
                    value={
                      partnerData?.businessAdditionalDetails?.dpin ??
                      "Not Applicable"
                    }
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <CardTitle className="mt-4 mb-4">Documents</CardTitle>

          <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
            Entity Documents
          </CardTitle>
          <div className="documents-section">
            {partnerData?.investorCompanyDetails?.pan_image && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.investorCompanyDetails.pan_image_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>PAN</p>
                    <Link
                      to={partnerData?.investorCompanyDetails.pan_image_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            )}
            {businessFiles.map((item, index) => (
              <React.Fragment key={`businessFiles_${index}`}>
                {partnerData?.businessAdditionalDetails?.[item.key] && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(
                        partnerData?.businessAdditionalDetails?.[item.key]
                      ) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>{item.label}</p>
                        <Link
                          to={
                            partnerData?.businessAdditionalDetails?.[
                              `${item.key}_url`
                            ]
                          }
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* <div className="verified-user">
                          <img src={check} alt="" /> Verified
                        </div> */}
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          <hr className="my-4" />
          <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
            Authorised Person Documents
          </CardTitle>
          <div className="documents-section">
            {partnerData?.investorsAadhaar?.aadhaar_file && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.investorsAadhaar.aadhaar_file_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Aadhaar</p>
                    <Link
                      to={partnerData?.investorsAadhaar.aadhaar_file_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}
            {/* {partnerData?.avatar_url && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(partnerData?.avatar_url) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Selfie</p>
                    <Link to={partnerData?.avatar_url} target="_blank">
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            )} */}
            {partnerData?.investorsPAN?.pan_file && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(partnerData?.investorsPAN?.pan_file_url) ===
                  "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>PAN</p>
                    <Link
                      to={partnerData?.investorsPAN?.pan_file_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}

            {partnerData?.businessAdditionalDetails?.authority_letter && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.businessAdditionalDetails?.authority_letter_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Authority Letter</p>
                    <Link
                      to={
                        partnerData?.businessAdditionalDetails
                          ?.authority_letter_url
                      }
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}
          </div>

          <hr className="my-4" />
          <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
            Banking Documents
          </CardTitle>
          <div className="documents-section">
            {partnerData?.investorsBankDetails?.cheque_file && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.investorsBankDetails.cheque_file_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Cheque</p>
                    <Link
                      to={partnerData?.investorsBankDetails.cheque_file_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}
          </div>

          {partnerData?.icdAgreements.length > 0 &&
            partnerData?.status === "APPROVED" && (
              <>
                <hr className="my-4" />
                <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                  Executed Documents
                </CardTitle>
                <div className="documents-section">
                  {partnerData?.icdAgreements.map((doc, index) => (
                    <div className="documents-box" key={`docs_${index}`}>
                      <div className="file-type">
                        <img src={pdfIcon} alt="" />

                        <div>
                          <p>
                            {`Agreement_${moment(doc.created_at).format("DD.MM.YYYY")}`}
                          </p>
                          <Link to={doc.doc_url} target="_blank">
                            <span className="text-small text-success cursor-pointer">
                              View
                            </span>
                          </Link>
                        </div>
                        <p></p>
                      </div>
                      {/* <div className="verified-user">
                                        <img src={check} alt="" /> Verified
                                      </div> */}
                    </div>
                  ))}
                </div>
              </>
            )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default NonIndividualView
